// src/constants.js – nový soubor
export const SHORTCUTS = [
  'Bia', 'Bee', 'Ble', 'Chre', 'Har', 'Hro', 'Hv', 'Šd', 'Šk', 'ValM',
  'Brz', 'Dvo', 'Dur', 'Koc', 'Krej', 'MarB', 'Pli', 'Sal', 'Sib', 'Žd',
  'ValJ', 'Pet', 'Hru', 'Kep', 'Kul', 'Mud', 'Pav', 'Pro', 'Koi', 'Švr', 'Mrk'
];